"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const mui_1 = require("tss-react/mui");
const ClearAll_1 = __importDefault(require("@mui/icons-material/ClearAll"));
const logoText_1 = __importDefault(require("components/logoText"));
const canvas_1 = __importDefault(require("./canvas"));
const useStyles = (0, mui_1.makeStyles)()((theme) => ({
    canvas: {
        height: '100%',
        width: '100%',
    },
    colors: {
        display: 'flex',
    },
    color: {
        borderRadius: '50%',
        height: '50px',
        width: '50px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '90%',
    },
    grouped: {
        borderRadius: '50%',
    },
    header: {
        height: 64,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'transparent',
        padding: 8,
        marginTop: 32,
        width: '100%',
        [theme.breakpoints.down('lg')]: {
            margin: 0,
        },
    },
    main: {
        height: '100vh',
        maxWidth: 1152,
        margin: '0  auto !important',
        '@media (min-width: 769px)': {
            marginLeft: theme.defaults.content.paddingLeft,
            marginRight: theme.defaults.content.paddingRight,
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    paletteSelector: {
        alignSelf: 'center',
    },
    paper: {
        boxShadow: '0 8px 24px 0 rgba(0, 0, 0, 0.15)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 200,
        width: '100%',
        [theme.breakpoints.down('lg')]: {
            background: 'none',
            margin: 16,
        },
    },
    toolarea: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.spacing(2),
    },
    toolbar: {
        justifyContent: 'center',
    },
}));
const StyledToggleButtonGroup = (0, mui_1.withStyles)(ToggleButtonGroup_1.default, (theme) => ({
    root: {
        justifyContent: 'center',
    },
    grouped: {
        margin: theme.spacing(2),
        border: 'none',
        borderRadius: '50%',
        '&:not(:first-child)': {
            borderRadius: '50%',
        },
        '&:not(:last-child)': {
            borderRadius: '50%',
        },
    },
}));
const StyledToggleButton = (0, mui_1.withStyles)(ToggleButton_1.default, () => ({
    root: {
        borderRadius: '50%',
    },
    selected: {
        border: 'black solid 2px',
    },
}));
const palettes = {
    default: {
        name: 'Default Palette',
        colors: ['#F4908E', '#F2F097', '#88B0DC', '#F7B5D1', '#53C4AF', '#FDE38C'],
    },
    PaulTol: {
        name: 'Paul Tol Palette',
        colors: ['#B997C6', '#824D99', '#4E79C4', '#57A2AC', '#7EB875', '#D0B440', '#E67F33'],
    },
};
const OfflinePage = () => {
    const canvasRef = (0, react_1.useRef)(null);
    const { classes } = useStyles();
    const theme = (0, styles_1.useTheme)();
    const [palette, setPalette] = (0, react_1.useState)(palettes.default);
    const [color, setColor] = (0, react_1.useState)(palettes.default.colors[0]);
    const handleClear = () => { var _a; return canvasRef && ((_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.clear()); };
    const handleColorChange = (_event, newColor) => setColor(newColor);
    const handlePaletteChange = (event) => {
        setPalette(event.target.value);
        setColor(event.target.value.colors[0]);
    };
    return (<>
      <react_helmet_1.Helmet>
        <title>{theme.project}</title>
        <meta name="offline" content="Offline Page"/>
      </react_helmet_1.Helmet>

      <div className={classes.main}>
        <div className={classes.header}>
          <logoText_1.default />
        </div>
        <Slide_1.default direction="up" in appear mountOnEnter unmountOnExit>
          <div className={classes.content}>
            <div>
              <Typography_1.default align="center" variant="h5">
                So, there&apos;s good news and bad news
              </Typography_1.default>
              <Typography_1.default align="center" variant="subtitle1">
                Bad news: It looks like you&apos;re offline
              </Typography_1.default>
              <Typography_1.default align="center" variant="subtitle1">
                Good news: Until we support working offline, you can draw a picture when offline
              </Typography_1.default>
              <Typography_1.default align="center" variant="body1">
                (pick a color and start drawing)
              </Typography_1.default>
            </div>
            <div className={classes.toolarea}>
              <Select_1.default className={classes.paletteSelector} value={palette} onChange={handlePaletteChange} inputProps={{ 'aria-label': 'Palette' }}>
                {Object.keys(palettes).map((key) => (<MenuItem_1.default key={key} value={palettes[key]}>{palettes[key].name}</MenuItem_1.default>))}
              </Select_1.default>
              <Toolbar_1.default className={classes.toolbar}>
                <StyledToggleButtonGroup classes={{
            grouped: classes.grouped,
        }} className={classes.colors} exclusive onChange={handleColorChange} value={color}>
                  {palette.colors.map((paletteColor, index) => (<StyledToggleButton aria-label={`color-${index}`} className={classes.color} sx={{ bgcolor: paletteColor }} value={paletteColor}/>))}
                </StyledToggleButtonGroup>
                <IconButton_1.default aria-label="Clear All" className={classes.button} color="primary" onClick={handleClear} size="large">
                  <ClearAll_1.default />
                </IconButton_1.default>
              </Toolbar_1.default>
            </div>
            <Paper_1.default className={classes.paper} square>
              <canvas_1.default className={classes.canvas} color={color} ref={canvasRef}/>
            </Paper_1.default>

          </div>
        </Slide_1.default>
      </div>
    </>);
};
exports.default = OfflinePage;
